<template>
          <div class="btn btn-info btn-sm" @click="$refs.fileButton.click()" v-if="isedit">
              <span>OCR</span>
            <input ref="fileButton" type="file" style="display: none;" v-on:change="OCRAttachment()" />
          </div>
</template>

<style>
#form-uploadS {
  display: block;
  height: 400px;
  width: 400px;
  background: #ccc;
  margin: auto;
  margin-top: 40px;
  text-align: center;
  line-height: 400px;
  border-radius: 4px;
}
</style>
<script>
import api from "@/api";
import config from "@/config";
import helper from "@/vueHelper";
import PDF from "@/components/fbpdfbox";
import ImageBox from "@/components/fbimagebox";

export default {
  name: "FileUpload",
  props: [
    "id",
    "value",
    "multiple",
    "fbreadonly",
    "fbrequired",
    "subTitle",
    "fbhidelabel",
    "labelwidth",
    "mb_form_table_id",
    "mb_form_table_type",
    "mb_form_column_id",
    "column_name",
    "ismobile",
    "fileresponse",
    "deleteFileList",
    "attachmentlist",
    "isedit",
    "fbinvisible",
    "saveLink",
    "accepts",
    "isDirectLink",
    "index",
    "fbtypedetail"
  ],
  components: {
    PDF,
    ImageBox
  },
  data() {
    return {
      uploadLimit: config.fileUploadLimit * 1000000 || 10000000, // default to 10M
      allowedFormat: config.fileUploadAllowedExtensions || null, // default to allow all
      isValid: true,
      isUploadError: false,
      errorMessage: "",
      view: false,
      myDropzone: null,
      lsaveLink:null,
      lmultiple:null,
    };
  },
  mounted() {
    this.lsaveLink = this.saveLink || "/userBuildForm/form01_file_save"
    this.lmultiple = this.multiple || true
    this.init();
  },
  methods: {
    init() {
      let vm = this;

      if (
        this.value != null &&
        this.value != undefined &&
        this.value.length > 0
      ) {
        $.each(this.value, function(key, file) {
          $(this.$el)
            .find("tbody")
            .append(`<tr><td><input type="text"/> </td></tr>`);
        });
      }

      let defaultMessage = helper.getWord("Drag files here to")+helper.getWord("upload");
      if (this.ismobile) {
        defaultMessage = "📷 "+helper.getWord("upload");
      }

      this.$nextTick(function() {
        setTimeout(function() {
          vm.myDropzone = $(vm.$refs.dropZoneForm).dropzone({
            paramName: "Files",
            dictDefaultMessage: defaultMessage,
            autoProcessQueue: false,
            url: config.serverURI + "/api" + vm.lsaveLink ,
            addRemoveLinks: true,
            clickable: true,
            withCredentials: !helper.includes(config.serverURI,"localhost")?true:false,
            parallelUploads: 5,
            maxFiles: 5,
            //acceptedFiles: vm.accepts||".jpg, .jpeg, .png, .pdf, .doc, .docx, .xlsx, .xls, .txt",
            acceptedFiles: vm.accepts|| "image/*, image/jpg, image/jpeg, image/gif, image/png, application/msword, application/vnd.ms-powerpoint, application/vnd.ms-excel, text/plain, application/pdf, application/zip, application/octet-stream, .txt, .xlsx, .docx, .png, .jpg, .jpeg, .gif",
            maxFilesize: 2,

            error: function(file, response) {
              helper.alert(response);
            },
            success: function(file, response) {
              console.log(response); //this is global one  depreciated // this is local one

              //WHY DELETE IT? It makes the saveForm Fail. Please finish another method before changing this method
               vm.fileresponse.push(response.data.tempFile); //this is global one  depreciated
                vm.attachmentlist.push(response.data.tempFile); // this is local one
              //this.isMobile=true;
              // vm.file[response.data.detail_index].push({sys_attachment_id: response.data.sys_attach_id, original_name: response.data.org_file_name})
              // if(vm.total_file_number_upload_success == vm.total_file_number_before_upload){
              //   vm.allFileSent();
              // }
            },
            complete: function(file) {
              this.removeFile(file);
            },
            init: function() {
              //var detail_index = i
              this.on("sending", function(file, xhr, formData) {
                formData.append("SessionID", helper.getSessionID());
                formData.append("LocaleCode", helper.getLocaleCode());
                formData.append("ApiKey", config.apiKey);
                formData.append("ApiSystemName", config.apiSystemName);
                var fileParams = [];
                fileParams.push({
                  mb_form_table_id: vm.mb_form_table_id,
                  mb_form_table_type: vm.mb_form_table_type,
                  mb_form_column_id: vm.mb_form_column_id,
                  column_name: vm.column_name,
                  name: "", //reserved when user could be able to input description tag.
                  isNew: true,
                  id:vm.id
                });
                formData.append("FileParams", JSON.stringify(fileParams));
              });
            },
            addedfiles: function(e){
              console.log(e);
            }
          });
        });
      });
    },
     async OCRAttachment(){
         var vm = this;
      if (this.isedit) {
        if(this.$refs.fileButton.files!=null&&this.$refs.fileButton.files.length>0){
          console.log(this.$refs.fileButton.files[0])
          let  reader = new FileReader();
          await reader.readAsDataURL(this.$refs.fileButton.files[0]);
         console.log(reader)
          reader.onload = function(e) {
                api.request(
                vm,
                "post",
                "/OCR/OCRFile",
                {
                SessionID: helper.getSessionID(),
                LocaleCode: helper.getLocaleCode(),
                Parameters: {
                    file: reader.result,
                    filename:vm.$refs.fileButton.files[0].name
                }
                },
                function(r) {
                vm.$emit("ocrfunction",r.data.OCRDate,r.data.OCRAmount,vm.fbtypedetail,vm.index);
                },
                function(r) {
                    vm.sessionErrorMsg = vm.$store.state.errorMsg;
                }
            );
        }
         }
  

        

      }
    },
    save(){
      let $vm = this;
      let $dropzones = $(".dropzone");
      let i,
        n = $dropzones.length;
        if (n > 0) {
          let dropZoneFlag = [];
          for (i = 0; i < n; i++) {
            dropZoneFlag.push(false);
            let myDropzone = Dropzone.forElement($dropzones[i]);
            let currentIndex = i;

            if (myDropzone.files.length != 0) {
              myDropzone.on("complete", function(file) {
                if (
                  this.getUploadingFiles().length === 0 &&
                  this.getQueuedFiles().length === 0
                ) {
                  dropZoneFlag[currentIndex] = true;
                }

                let j;
                let isAllComplete = true;
                for (j = 0; j < dropZoneFlag.length; j++) {
                  if (dropZoneFlag[j] == false) {
                    isAllComplete = false;
                    break;
                  }
                }
                if (isAllComplete) {
                  console.log("all complete");
                  // console.log($vm.fileresponse)
                  //$vm.$forceUpdate();
                }
              });
            } else {
              dropZoneFlag[currentIndex] = true;
              let j;
              let isAllComplete = true;
              if ($dropzones.length == dropZoneFlag.length) {
                for (j = 0; j < dropZoneFlag.length; j++) {
                  if (dropZoneFlag[j] == false) {
                    isAllComplete = false;
                    break;
                  }
                }
                if (isAllComplete) {
                  console.log("all complete");
                  // console.log($vm.fileresponse)

                }
              }
            }
          }
          for (i = 0; i < n; i++) {
            let myDropzone = Dropzone.forElement($dropzones[i]);
            if (myDropzone.files.length != 0) {
              myDropzone.processQueue();
            }
          }
        }
    }
  },
  computed: {
    labelCol() {
      return this.labelwidth || 3;
    },
    isAzure(){
      return helper.getParam("STORE_METHOD")=="2"?true:false
    }
  },
  watch: {
    isedit: function() {
      this.init();
    }
  }
};
</script>
<style scoped>
.media-body {
  min-height: 38px;
  border: 1px solid #ddd;
}
.zone {
  margin: auto;
  text-align: center;
  z-index: 20;
  transition: all 0.3s ease-out;
  border: 3px solid #fff;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.05),
    inset 0 0 0.25em 0 rgba(0, 0, 0, 0.25);
}
.zone i {
  text-align: center;
  font-size: 3em;
  margin-top: 15px;
}
.zone .selectFile {
  height: 40px;
  margin: 10px auto;
  position: relative;
  width: 200px;
}
.zone label,
.zone input {
  cursor: pointer;
  display: block;
  height: 30px;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  border-radius: 5px;
}
.zone label {
  color: #fff !important;
  display: inline-block;
  font-size: 1.2em;
  line-height: 30px;
  padding: 0;
  text-align: center;
  white-space: nowrap;
  text-transform: uppercase;
  font-weight: 400 !important;
  box-shadow: 0 1px 1px gray;
}
.zone input[type="file"] {
  opacity: 0 !important;
}
.zone.hover {
  color: gray;
  border-color: white;
  background: #fff;
  border: 3px dashed gray;
}
.zone.hover label {
  background: grey;
}
.zone.fade {
  transition: all 0.3s ease-out;
  opacity: 1;
}
.dropdown-item small {
  margin-left: 10px;
  vertical-align: bottom;
}
@media (max-width: 575.98px) {
  .dropzone .dz-message {
    margin: 2em 0 2em 0;
  }
}
</style>
